import React, { useState } from 'react';
import { TextInput } from 'react-admin';
import { Grid } from '@material-ui/core/';
import DocumentTypeApi from '../../core/apis/DocumentTypeApi';
import { isStringContainingLessThanOrGreaterThanOrEqualsSign } from '../../core/utils';

const DocumentTypeSummary = ({ record, ...props }) => {
  const [formErrors, setFormErrors] = useState({});
  /*
   * Verify that document type description is unique
   */
  const validateDescription = async (value, allValues, props) => {
    if (record && value === record.description) {
      return;
    }
    if (props.active) {
      let error;

      const descExists = await DocumentTypeApi.checkDescriptionExists(value);
      if (descExists) {
        error = 'Description already exists';
      } else {
        error = undefined;
      }
      setFormErrors({ ...formErrors, id: error });
      return error;
    }
    return formErrors.id;
  };

  const notBlank = (message = 'Required') => value =>
    value !== undefined && value.trim() !== '' ? undefined : message;

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={6}>
        <TextInput
          source="description"
          label="Document Type"
          validate={[
            notBlank(),
            isStringContainingLessThanOrGreaterThanOrEqualsSign,
            validateDescription
          ]}
          options={{ autoComplete: 'off' }}
          variant="standard"
        />
      </Grid>
    </Grid>
  );
};

export default DocumentTypeSummary;
